import fetchServer from "../fetchServer";


export default async function createOrderPriceAdjustments(data) {
  let result = { return: 0, msg: "Something went wrong Adding Price Adjustment!" };

  await fetchServer({
    method: "POST",
    url: "/product/v1/adminOtherPriceAdjustment",data,
  })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data };
      } else result["msg"] = res?.data?.error || result["msg"];
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
